import { Typography } from '@mui/material';
import { useParams } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogActions } from 'src/components/molecules/dialog';
import { useUnassignSpaceGroupFromEmployeeGroup } from 'src/features/employees-groups/api/hooks/space-groups/use-unassign-space-group-from-employee-group';

interface Props extends DialogActions {
  spaceGroupToken: string;
  spaceGroupName: string;
  employeeGroupName: string;
}

export const UnassignSpaceGroupFromEmployeeGroup = ({
  open,
  onCancel,
  spaceGroupToken,
  spaceGroupName,
  employeeGroupName,
}: Props) => {
  const { t } = useTranslation(['employeesGroups', 'common']);

  const { employeeGroupToken } = useParams({
    from: '/_layout/tenant/employees/groups/$groupToken/_layout/space-groups',
    select(state) {
      return {
        employeeGroupToken: state.groupToken,
      };
    },
  });

  const {
    mutate: unassignSpaceGroupFromEmployeeGroup,
    isPending: isUnassigningSpaceGroupFromEmployeeGroup,
  } = useUnassignSpaceGroupFromEmployeeGroup(onCancel);

  const handleUnassignSpaceGroupFromEmployeeGroup = () => {
    unassignSpaceGroupFromEmployeeGroup({
      employeeGroupToken,
      spaceGroupToken,
      bookingsDecisions: {
        moveBookingDecisions: [],
        cancelBookingDecisions: [],
        keepBookingUnchangedDecisions: [],
      },
      bookingsDecisionsReason: t(
        'employeesGroups:spaceGroups.bookingsDecisionsReason',
      ),
    });
  };

  return (
    <Dialog
      variant="warning"
      title={t(
        'employeesGroups:spaceGroups.unassignSpaceGroupFromEmployeeGroupDialog.title',
      )}
      open={open}
      onCancel={onCancel}
      cancelButtonText={t('common:button.no')}
      onConfirm={handleUnassignSpaceGroupFromEmployeeGroup}
      confirmButtonText={t(
        'employeesGroups:spaceGroups.unassignSpaceGroupFromEmployeeGroupDialog.confirmButtonText',
      )}
      isConfirmButtonSubmitting={isUnassigningSpaceGroupFromEmployeeGroup}>
      <Typography variant="body2">
        {t(
          'employeesGroups:spaceGroups.unassignSpaceGroupFromEmployeeGroupDialog.description',
          {
            spaceGroupName,
            employeeGroupName,
          },
        )}
      </Typography>
    </Dialog>
  );
};
